// src/utils/routeResolver.js
async function resolveRouteWithCoords(

  routeString,

  origin,

  destination,

  cruiseAlt,

  departureRunway = null,
  selectedSid = null,
  selectedSidTransition = null,

  arrivalRunway = null,
  selectedStar = null,
  selectedStarTransition = null,

  selectedApproach = null,
  selectedArrivalIAF = null

) {

  if (!routeString || !origin || !destination) {

    throw new Error(
      "Missing route parameters"
    );
  }

  const originUpper = origin.trim().toUpperCase();
  const destinationUpper = destination.trim().toUpperCase();

  // Split route into tokens
  let tokens = routeString.trim().toUpperCase().split(/\s+/);

  // Remove origin/destination if user included them
  if (tokens[0] === originUpper) tokens.shift();
  if (tokens[tokens.length - 1] === destinationUpper) tokens.pop();

  const cleanedRoute = tokens.join(" ");

  console.log(
  "🚨 ROUTE RESOLVER PAYLOAD",
  {

    route: cleanedRoute,

    origin,
    destination,

    altitude: cruiseAlt,

    departureRunway,
    selectedSid,
    selectedSidTransition,

    arrivalRunway,
    selectedStar,
    selectedStarTransition,

    selectedApproach,
    selectedArrivalIAF
  }
);

  const res = await fetch("https://ficon-x.com/route/resolve_manual_route", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
body: JSON.stringify({

  route: cleanedRoute,

  origin,
  destination,

  altitude: cruiseAlt,

  departureRunway,
  selectedSid,
  selectedSidTransition,

  arrivalRunway,
  selectedStar,
  selectedStarTransition,

  selectedApproach,
  selectedArrivalIAF
}),
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error(`Route resolver failed (${res.status}): ${text}`);
  }

  const data = await res.json();

  return data;
}

export default resolveRouteWithCoords;